import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Switch,
} from "@mui/material";
import {
  Calculate,
  CalendarMonth,
  RequestQuote,
  Summarize,
} from "@mui/icons-material";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemErro from "../../components/MensagemErro";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import ExportExcelButton from "../../components/ExportExcelButton";
import GenericYearMonthPicker from "../../components/GenericYearMonthPicker";
import GenericTextIdAutoCompleteSelect from "../../components/GenericTextIdAutoCompleteSelect";
import { obterResumoGeralFolha, obterResumoGeralFolhaFiltrado } from "../../services/api-esocial.service";
import { buscarComboPorCodigo } from "../../services/api-autenticacao.service";
import { formatToBRL } from "../../utils/currency.util";
import { simplifyString } from "../../utils/simplify_string";
import styles from "./styles.module.css";

const CODIGOS_BENEFICIOS = [
  // DESCONTOS
  '1801D','1802D','1803D','1810D','1814ID','1817D','1826D','1827D','1827DR',
  '1877D','1966D','1966DR','1967D','1967DR','1994D','2402D','2410D','2427D',
  '2431D','2443D','2800D','2804D','2804ID','2805D','2805ID','2806D','2806ID',
  '2807D','2807ID','2808D','2808ID','2809D','2809ID','2815D','2815ID','2818D',
  '2821D','2823D','2825D','2826D','2826ID','2827D','2827ID','2828D','2828ID',
  '2829D','2829ID','2831D','2836D','2837D','2838D','2841D','2843D','2846D',
  '2848D','2849D','2850D','2854D','2855D','2860D','2861D','2867D','2867ID',
  '2871D','2871ID','2872D','2872ID','2873D','2873ID','2874D','2874ID','2875D',
  '2875ID','2876D','2876ID','2877D','2877ID','2883D','2883ID','2884D','2884ID',
  '28A1D','28A2D','28A3D','28A4D','28A5D','28A6D','28A7D','28A8D','28A9D',
  '28B1D','28B2D','28B3D','28B4D','28B5D','28B6D','28B7D','28B8D','28B9D',
  '28C0D','28C1D','28C2D','28C3D','28C4D','28C5D','28C6D','28C7D','28C8D','28C9D',
  '28D1D','28D2D','28D3D','28D4D','28D5D','28D6D','28D7D','28D8D','28D9D',
  '28E1D','28E2D','28E3D','28E4D','28E5D','28E6D','28E7D','28E8D',
  '28F1D','28F6D','28F7D','28F8D',
  '28G0D','28G1D','28G2D','28G3D','28G4D','28G5D','28G6D','28G7D','28G8D','28G9D','28GID',
  '28H1D','28H2D','28H3D','28H4D','28H5D','28H6D','28H7D','28H8D','28H9D',
  '28I1D','28I2D','28I3D','28I4D','28I5D','28I6D','28I7D','28I8D','28I9D',
  '28J1D','28J2D','28J3D','28J4D','28J5D','28J6D','28J7D','28J8D','28J9D',
  '28K0D','28K1D','28K2D','28K3D','28K4D','28K5D','28K6D','28K7D','28K8D','28K9D','28KAD',
  '28L0D','28L1D','28L2D','28L3D','28L4D','28L5D','28L6D','28L7D','28L8D','28L9D',
  '28M1D','28M2D','28M3D','28M4D','28M5D','28M6D','28M7D','28M8D','28M9D',
  '28N1D','28N2D','28N3D','28N4D','28N5D','28N6D','28N7D','28N8D','28N9D',
  '28O1D','28O2D','28O3D','28O4D','28O5D','28O6D','28O7D','28O8D','28O9D',
  '28P1D','28P2D','28P3D','28P4D','28P5D','28P9D',
  '28Q1D','28Q2D','28Q3D','28Q4D','28Q5D','28Q6D','28Q7D','28Q8D','28Q9D',
  '28R1D','28R2D','28R3D','28R4D','28R5D','28R6D','28R7D','28R8D','28R9D',
  '28S1D','28S2D','28S3D','28S4D','28S5D','28S6D','28S7D','28S8D','28S9D',
  '28T1D','28T2D','28T3D','28T4D','28T5D','28T6D','28T7D','28T8D','28T9D',
  '28U0D','28U1D','28U2D','28U3D','28U4D','28U5D','28U6D','28U7D','28U8D','28U9D',
  '28V0D','28V1D','28V2D','28V3D','28V4D','28V5D','28V6D','28V7D','28V8D','28V9D',
  '28W1D','28W2D','28W3D',
  '28X0D','28X1D','28X2D','28X3D','28X4D','28X5D','28X6D','28X7D','28X8D','28X9D',
  '28Y0D','28Y1D','28Y2D','28Y3D','28Y4D','28Y6D','28Y7D','28Y8D',
  '28Z1D','28Z2D','28Z3D','28Z4D','28Z5D','28Z6D','28Z8D',
  '2921D','2922D','2923D','2966D','2966ID','2967D','2967ID','2968D','2968ID',
  '29A1D','29A2D','29A3D','29A4D','29A5D','29A6D','29A7D','29A8D','29A9D',
  '29B1D','29B2D','29B3D','29B4D','29B5D','29B6D',
  '29DFD','29E1D','29E2D','29G1D','29G2D','29G3D','29G4D',
  '29N1D','29N2D','29N3D','29N4D','29N5D','29N6D','29N7D','29N8D','29N9D','29NAD',
  '29OUD','29P1D','29P2D','29P3D','29P4D','29P5D','29P6D',
  '29QCD','29QPD','29R1D','29R2D','29RJD','29SPD','29V1D',
  'D/505D','D/507D','BA10D','BA11D','BA12D','BA13D','BA14D','BA20D','BA21D','BA50D',
  'M400D','MVR0D',
  // PROVENTOS
  '0070P','0071P','0080P','1417P','1425P','1426P','1439P','1449P','1455P',
  '1462P','1467P','1468P','1469P','1471P','1472P','1487P','1489P','1500P',
  '1506P','1513P','1514P','1522P','1523P','1525P','1526P','1531P','1543P',
  '1597P','1605P','1845P','1854P','1855P','1856P','1857P','1876P','1884P',
  '1884PR','1885P','1886P','1886PR','1891P','1891PR','1901P','1901PR',
  '1951P','1984P','1984PR','1985P','1992P','1996P','1996PR','1997P','1999P',
  '1999PR','2036P','2037P','2039P','2039PR','2406P','2407P','2437P','2438P',
  '2440P','2441P','2442P','2443P','2445P',
  'C/314PC','C/353I','C/354I','C/358I','C/359I','C/362I',
  'M030P','M180P','MC04P','MC05P','MC14P','MC15P',
  'MZ05P','MZ06P','MZ12P','MZ14P','MZ15P','MZ16P',
  'MZ80P','MZ82P','MZ83P','MZ86P','MZ87P','MZ88P',
  '/R20P','/T38P','/T50P','/T55P','/T5AP','/T5BP','/T5CP',
  '/T60P','/T80P','/T81I','/T85P','/T90P','/T92P','/T93P','/T94P',
  '/V23P','/V29P','/V39I','/V39IR','/V40P','/V51P','/V55P','/V56P','/V75P','/V86P',
  '9ATTP','9ATTPR','MT80P','/R10P','/V50P','/V85P'
];

/** No estado do grupo/CNPJ, `CNPJ` guarda id(s) de empresa vindos do combo, não o número do CNPJ. */
function normalizarIdsEmpresaResumo(cnpjVal) {
  if (cnpjVal == null) return [];
  const arr = Array.isArray(cnpjVal) ? cnpjVal : [cnpjVal];
  return arr
    .filter((id) => id != null && id !== "")
    .map((id) => parseInt(String(id), 10))
    .filter((id) => !Number.isNaN(id) && id > 0);
}

const ResumoGeral = () => {
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [grupoECnpj, setGrupoECnpj] = useState({});
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [filtroContas, setFiltroContas] = useState([]);
  const [filtroComposicaoProjeto, setFiltroComposicaoProjeto] = useState(true);

  const [calculoRelatorio, setCalculoRelatorio] = useState("geral");
  const [sefipRelatorio, setSefipRelatorio] = useState(false);
  const [verbasRelatorio, setVerbasRelatorio] = useState("Completo");
  const [filtroBeneficios, setFiltroBeneficios] = useState(false);

  const toBRLdiv = (str) => {
    return <div>{formatToBRL(Number(str))}</div>;
  };

  const toTwoDecimals = (val) => {
    return Number(Number(val).toFixed(2));
  };

  const toMMYYYY = (fromYYYYMM) => {
    return fromYYYYMM.split("-")[1] + "/" + fromYYYYMM.split("-")[0];
  };

  const toMMYYYYdiv = (fromYYYYMM) => {
    return (
      <div>{fromYYYYMM.split("-")[1] + "/" + fromYYYYMM.split("-")[0]}</div>
    );
  };

  const geralColumns = [
    {
      id: "periodoApuracao",
      label: "Período",
      render: (row) => toMMYYYYdiv(row.periodoApuracao),
    },
    { id: "codigoRubrica", label: "Código", field: "codigoRubrica_cellVal" },
    { id: "descricaoRubrica", label: "Descrição", field: "descricaoRubrica" },
    {
      id: "incidenciaRubrica",
      label: "Incidência",
      field: "incidenciaRubrica",
    },
    {
      id: "valorRubrica",
      label: "Valor",
      render: (row) => toBRLdiv(row.valorRubrica),
      type: "numerico",
    },
    {
      id: "totalGeral",
      label: "Geral",
      render: (row) => toBRLdiv(row.totalGeral),
      type: "numerico",
    },
    {
      id: "totalGeralCorrigido",
      label: "Geral Corrigido",
      render: (row) => toBRLdiv(row.totalGeralCorrigido),
      type: "numerico",
    },
    {
      id: "totalGeralCalculado",
      label: "Geral Correção",
      render: (row) => toBRLdiv(row.totalGeralCalculado),
      type: "numerico",
    },
  ];

  const geralSefipColumns = [
    { id: "cnpj", label: "CNPJ", field: "cnpj" },
    {
      id: "periodoApuracao",
      label: "Período",
      render: (row) => toMMYYYYdiv(row.periodoApuracao),
    },
    {
      id: "totalGeralCorrigido",
      label: "Geral Corrigido",
      render: (row) => toBRLdiv(row.totalGeralCorrigido),
      type: "numerico",
    },
    { id: "cargaSefipGeral", label: "Carga Sefip", field: "cargaSefipGeral" },
  ];

  const cprbColumns = [
    {
      id: "periodoApuracao",
      label: "Período",
      render: (row) => toMMYYYYdiv(row.periodoApuracao),
    },
    { id: "codigoRubrica", label: "Código", field: "codigoRubrica_cellVal" },
    { id: "descricaoRubrica", label: "Descrição", field: "descricaoRubrica" },
    {
      id: "incidenciaRubrica",
      label: "Incidência",
      field: "incidenciaRubrica",
    },
    {
      id: "valorRubrica",
      label: "Valor",
      render: (row) => toBRLdiv(row.valorRubrica),
      type: "numerico",
    },
    {
      id: "totalCprb",
      label: "CPRB",
      render: (row) => toBRLdiv(row.totalCprb),
      type: "numerico",
    },
    {
      id: "totalCprbCorrigido",
      label: "CPRB Corrigido",
      render: (row) => toBRLdiv(row.totalCprbCorrigido),
      type: "numerico",
    },
    {
      id: "totalCprbCalculado",
      label: "CPRB Correção",
      render: (row) => toBRLdiv(row.totalCprbCalculado),
      type: "numerico",
    },
  ];

  const cprbSefipColumns = [
    { id: "cnpj", label: "CNPJ", field: "cnpj" },
    {
      id: "periodoApuracao",
      label: "Período",
      render: (row) => toMMYYYYdiv(row.periodoApuracao),
    },
    {
      id: "totalCprbCorrigido",
      label: "CPRB Corrigido",
      render: (row) => toBRLdiv(row.totalCprbCorrigido),
      type: "numerico",
    },
    { id: "cargaSefipCprb", label: "Carga Sefip", field: "cargaSefipCprb" },
  ];

  const [currentColumns, setCurrentColumns] = useState(geralColumns);

  useEffect(() => {
    const idsResumo = normalizarIdsEmpresaResumo(grupoECnpj.CNPJ);

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await obterResumoGeralFolha({
          cnpjs: Array.isArray(grupoECnpj.CNPJ) ? grupoECnpj.CNPJ : [grupoECnpj.CNPJ],
          ...(filtroBeneficios && { codigos: CODIGOS_BENEFICIOS }),
        });
        const resumo = response.resumos.map((item) => {
          return {
            ...item,
            codigoRubrica_cellVal: simplifyString(item.codigoRubrica),
          };
        });
        console.log(resumo);
        
        // const listaContas = []
        // for (let index = 0; index < grupoECnpj.CNPJ.length; index++) {
        //   const cnpjAtual = grupoECnpj.CNPJ[index];
        //   const contas = await buscarComboPorCodigo(`ESOCIAL_CONTAS_COMPOSICAO_${cnpjAtual}`)
        //   const organizaContas = contas.detalhes.itensCombo.map((item) => {
        //     const splitValues = item.split("/|/");
        //     return {
        //       id: splitValues[0],
        //       label: splitValues[1],
        //     };
        //   });
        //   listaContas.push(...organizaContas)
        // }
        // listaContas.unshift(
        //   {
        //     id: undefined,
        //     label: 'Selecionar todos',
        //     selectAll: true
        //   }
        // )
        setData(resumo);
        setLoading(false);
      } catch (err) {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
        setLoading(false);
      }
    };

    if (grupoECnpj.GE && idsResumo.length > 0) {
      fetchData();
    } else {
      setData([]);
      setCurrentData([]);
      setFiltroContas([]);
    }
  }, [grupoECnpj, filtroBeneficios]);

  useEffect(() => {
    if (calculoRelatorio === "geral") {
      if (sefipRelatorio) {
        setCurrentColumns(geralSefipColumns);
      } else {
        setCurrentColumns(geralColumns);
      }
    } else if (calculoRelatorio === "cprb") {
      if (sefipRelatorio) {
        setCurrentColumns(cprbSefipColumns);
      } else {
        setCurrentColumns(cprbColumns);
      }
    }
  }, [calculoRelatorio, sefipRelatorio]);

  useEffect(() => {
    if (sefipRelatorio) {
      setCurrentData(
        setSefipData(verbasRelatorio, filtroContas, dataInicio, dataFinal)
      );
    } else {
      setCurrentData(
        filterSetData(verbasRelatorio, filtroContas, dataInicio, dataFinal)
      );
    }
  }, [
    data,
    calculoRelatorio,
    sefipRelatorio,
    verbasRelatorio,
    filtroContas,
    dataInicio,
    dataFinal,
    filtroComposicaoProjeto,
  ]);

  const filterSetData = (
    filtroVerbas,
    filtroContas,
    filtroInicio,
    filtroFim
  ) => {
    let returnData = data;

    if (filtroComposicaoProjeto) {
      returnData = returnData.filter((obj) => obj.composicaoProjeto === true);
    }

    if (filtroVerbas !== "Completo") {
      returnData = returnData.filter((obj) => obj.tipoRubrica === filtroVerbas);
    }

    if (filtroContas.length > 0) {
      returnData = returnData.filter((obj) =>
        filtroContas.some((filtro) => filtro.codigoRubrica == obj.codigoRubrica)
      );
    }

    if (!filtroInicio && !filtroFim) {
      const currentDate = new Date();
      const startDate = new Date(
        currentDate.getFullYear() - 5,
        currentDate.getMonth() - 1,
        1
      );

      returnData = returnData.filter((obj) => {
        const [year, month] = obj.periodoApuracao.split("-").map(Number);
        const objDate = new Date(year, month - 1);
        return objDate >= startDate && objDate <= currentDate;
      });
    }

    if (filtroInicio) {
      returnData = returnData.filter(
        (obj) => obj.periodoApuracao >= filtroInicio
      );
    }

    if (filtroFim) {
      returnData = returnData.filter((obj) => obj.periodoApuracao <= filtroFim);
    }

    return returnData;
  };

  const setSefipData = (
    filtroVerbas,
    filtroComposicaoProjeto,
    filtroAusentesRubrica,
    filtroContas,
    filtroInicio,
    filtroFim
  ) => {
    let somas = new Map();
    let cnpj;

    let resultData = filterSetData(
      filtroVerbas,
      filtroComposicaoProjeto,
      filtroAusentesRubrica,
      filtroContas,
      filtroInicio,
      filtroFim
    );

    resultData.forEach((verba) => {
      if (!cnpj) cnpj = verba.cnpj;
      if (!somas.has(verba.periodoApuracao)) {
        somas.set(verba.periodoApuracao, {
          geral: toTwoDecimals(verba.totalGeralCorrigido),
          cprb: toTwoDecimals(verba.totalCprbCorrigido),
        });
      } else {
        somas.set(verba.periodoApuracao, {
          geral:
            somas.get(verba.periodoApuracao).geral +
            toTwoDecimals(verba.totalGeralCorrigido),
          cprb:
            somas.get(verba.periodoApuracao).cprb +
            toTwoDecimals(verba.totalCprbCorrigido),
        });
      }
    });

    let aggregateData = [];

    somas.forEach((value, key) => {
      aggregateData.push({
        cnpj: cnpj,
        periodoApuracao: key,
        totalGeralCorrigido: toTwoDecimals(value.geral),
        totalCprbCorrigido: toTwoDecimals(value.cprb),
        cargaSefipGeral:
          cnpj.replaceAll(/[\.\/-]/g, "") +
          "|" +
          key.split("-")[0] +
          "|" +
          key.split("-")[1] +
          "|" +
          toTwoDecimals(value.geral),
        cargaSefipCprb:
          cnpj.replaceAll(/[\.\/-]/g, "") +
          "|" +
          key.split("-")[0] +
          "|" +
          key.split("-")[1] +
          "|" +
          toTwoDecimals(value.cprb),
      });
    });

    return aggregateData;
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleGrupoECnpjChange = (ids) => {
    setGrupoECnpj(ids);
  };

  const handleDataInicial = (data) => {
    if (!data) {
      setDataInicio(undefined);
      return;
    }
    const splitData = data.toLocaleDateString("pt-BR").split("/");
    if (!splitData[2] || !splitData[1] || splitData[2].length < 4) {
      setDataInicio(undefined);
      return;
    }
    const novaData = `${splitData[2]}-${splitData[1]}`;
    setDataInicio(novaData);
  };

  const handleDataFinal = (data) => {
    if (!data) {
      setDataFinal(undefined);
      return;
    }
    const splitData = data.toLocaleDateString("pt-BR").split("/");
    if (!splitData[2] || !splitData[1] || splitData[2].length < 4) {
      setDataFinal(undefined);
      return;
    }
    const novaData = `${splitData[2]}-${splitData[1]}`;
    setDataFinal(novaData);
  };

  const obterCabecalho = async (worksheet) => {
    worksheet.mergeCells("A1:H1");
    const resumoCell = worksheet.getCell("A1");
    resumoCell.value = "Resumo Da Folha";
    resumoCell.font = {
      name: "SansSerif",
      size: 19,
      bold: true,
      color: { argb: "000080" },
    };
    resumoCell.alignment = { vertical: "middle", horizontal: "left" };

    worksheet.mergeCells("I1:K1");
    const tmCell = worksheet.getCell("I1");
    tmCell.value = "Taxation Mind";
    tmCell.font = {
      name: "SansSerif",
      size: 19,
      bold: true,
      color: { argb: "000080" },
    };
    tmCell.alignment = { vertical: "middle", horizontal: "center" };

    worksheet.mergeCells("A2:H2");
    const periodoCell = worksheet.getCell("A2");
    periodoCell.value = `Periodo de Busca: ${
      dataInicio
        ? convertDateFormat(dataInicio)
        : convertDateFormat(
            getYYYYMMDateString(
              new Date(
                new Date().getFullYear() - 5,
                new Date().getMonth() - 1,
                1
              )
            )
          )
    } à ${
      dataFinal
        ? convertDateFormat(dataFinal)
        : convertDateFormat(getYYYYMMDateString(new Date()))
    }`;
    periodoCell.font = { name: "SansSerif", size: 11 };
    periodoCell.alignment = { vertical: "middle", horizontal: "left" };

    worksheet.mergeCells("A3:H3");
    const grupoCell = worksheet.getCell("A3");
    grupoCell.value = `Grupo: ${grupoECnpj.nome_GE}`;
    grupoCell.font = { name: "SansSerif", size: 8 };
    grupoCell.alignment = { vertical: "middle", horizontal: "left" };

    worksheet.mergeCells("A4:H4");
    const empresaCell = worksheet.getCell("A4");
    // empresaCell.value = `Empresa: ${grupoECnpj.nome_CNPJ.split('-')[0]} - ${grupoECnpj.nome_CNPJ.split('-')[1]}`;
    empresaCell.font = { name: "SansSerif", size: 8 };
    empresaCell.alignment = { vertical: "middle", horizontal: "left" };

    worksheet.getRow(1).height = 50;
    worksheet.getRow(2).height = 25;

    return 5;
  };

  function convertDateFormat(dateString) {
    const [year, month] = dateString.split("-");
    return `${month}/${year}`;
  }

  function getYYYYMMDateString(date) {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}`;
  }

  const obterRelatorio = async () => {
    return sefipRelatorio ? obterRelatorioSefip() : obterRelatorioGeral();
  };

  const obterRelatorioGeral = async () => {
    const reportData = [];
    let fileName = `resumo_geral_${grupoECnpj.CNPJ[0]}`;
    let cnpj;

    let periodos = new Set();
    const verbasProventoPorMes = new Map();
    const verbasDescontoPorMes = new Map();
    const verbasAusentesPorMes = new Map();

    currentData.forEach((verba) => {
      if (!cnpj) cnpj = verba.cnpj;
      periodos.add(verba.periodoApuracao);
      switch (verba.tipoRubrica) {
        case "Provento":
          if (!verbasProventoPorMes.has(verba.periodoApuracao)) {
            verbasProventoPorMes.set(verba.periodoApuracao, [verba]);
          } else {
            verbasProventoPorMes.set(verba.periodoApuracao, [
              ...verbasProventoPorMes.get(verba.periodoApuracao),
              verba,
            ]);
          }
          break;
        case "Desconto":
          if (!verbasDescontoPorMes.has(verba.periodoApuracao)) {
            verbasDescontoPorMes.set(verba.periodoApuracao, [verba]);
          } else {
            verbasDescontoPorMes.set(verba.periodoApuracao, [
              ...verbasDescontoPorMes.get(verba.periodoApuracao),
              verba,
            ]);
          }
          break;
        default:
          if (!verbasAusentesPorMes.has(verba.periodoApuracao)) {
            verbasAusentesPorMes.set(verba.periodoApuracao, [verba]);
          } else {
            verbasAusentesPorMes.set(verba.periodoApuracao, [
              ...verbasAusentesPorMes.get(verba.periodoApuracao),
              verba,
            ]);
          }
          break;
      }
    });
    
    let sortedSetArray = Array.from(periodos).sort((a, b) => a - b);
    periodos = new Set(sortedSetArray);
    
    const somas = {
      valorBase: 0,
      inss: 0,
      terceiros: 0,
      rat: 0,
      total: 0,
      inssCorrigido: 0,
      terceirosCorrigido: 0,
      ratCorrigido: 0,
      totalCorrigido: 0,
      valorCorrecao: 0,
    };
    
    let somasTotal = { ...somas };
    
    periodos.forEach((value) => {
      console.log(verbasDescontoPorMes.get(value));
      const somasMensal = { ...somas };
      const somasProvento = { ...somas };
      const somasDesconto = { ...somas };

      let verbasProventoPeriodo = verbasProventoPorMes.get(value);

      verbasProventoPeriodo = verbasProventoPeriodo
        ? verbasProventoPeriodo.sort((a, b) => {
            if (a.codigoRubrica < b.codigoRubrica) return -1;
            if (a.codigoRubrica > b.codigoRubrica) return 1;
            if (a.idTabelaRubrica < b.idTabelaRubrica) return -1;
            if (a.idTabelaRubrica > b.idTabelaRubrica) return 1;
            return 0;
          })
        : [];
      verbasProventoPeriodo.forEach((verba) => {
        reportData.push({
          "<style bold>Período</style>": toMMYYYY(verba.periodoApuracao),
          "<style bold>CNPJ</style>": verba.cnpj,
          "<style bold>Código</style>": verba.codigoRubrica,
          "<style bold>Evento</style>": verba.descricaoRubrica,
          "<style bold>Incidência</style>": verba.incidenciaRubrica,
          "<style bold>Valor Base</style>": toTwoDecimals(verba.valorRubrica),
          "<style bold>INSS</style>": toTwoDecimals(verba.inss),
          "<style bold>Terceiros</style>": toTwoDecimals(verba.terceiros),
          "<style bold>Rat</style>": toTwoDecimals(verba.rat),
          "<style bold>Total</style>":
            calculoRelatorio === "geral"
              ? toTwoDecimals(verba.totalGeral)
              : toTwoDecimals(verba.totalCprb),
          "<style bold>INSS Corrigido</style>": toTwoDecimals(
            verba.inssCorrigido
          ),
          "<style bold>Terceiros Corrigido</style>": toTwoDecimals(
            verba.terceirosCorrigido
          ),
          "<style bold>Rat Corrigido</style>": toTwoDecimals(
            verba.ratCorrigido
          ),
          "<style bold>Total Corrigido</style>":
            calculoRelatorio === "geral"
              ? toTwoDecimals(verba.totalGeralCorrigido)
              : toTwoDecimals(verba.totalCprbCorrigido),
          "<style bold>Selic</style>": toTwoDecimals(verba.selic),
          "<style bold>Valor Correção</style>":
            calculoRelatorio === "geral"
              ? toTwoDecimals(verba.totalGeralCalculado)
              : toTwoDecimals(verba.totalCprbCalculado),
        });
        somasProvento.valorBase += toTwoDecimals(verba.valorRubrica);
        somasProvento.inss += toTwoDecimals(verba.inss);
        somasProvento.terceiros += toTwoDecimals(verba.terceiros);
        somasProvento.rat += toTwoDecimals(verba.rat);
        somasProvento.total +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeral)
            : toTwoDecimals(verba.totalCprb);
        somasProvento.inssCorrigido += toTwoDecimals(verba.inssCorrigido);
        somasProvento.terceirosCorrigido += toTwoDecimals(
          verba.terceirosCorrigido
        );
        somasProvento.ratCorrigido += toTwoDecimals(verba.ratCorrigido);
        somasProvento.totalCorrigido +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCorrigido)
            : toTwoDecimals(verba.totalCprbCorrigido);
        somasProvento.valorCorrecao +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCalculado)
            : toTwoDecimals(verba.totalCprbCalculado);

        somasMensal.valorBase += toTwoDecimals(verba.valorRubrica);
        somasMensal.inss += toTwoDecimals(verba.inss);
        somasMensal.terceiros += toTwoDecimals(verba.terceiros);
        somasMensal.rat += toTwoDecimals(verba.rat);
        somasMensal.total +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeral)
            : toTwoDecimals(verba.totalCprb);
        somasMensal.inssCorrigido += toTwoDecimals(verba.inssCorrigido);
        somasMensal.terceirosCorrigido += toTwoDecimals(
          verba.terceirosCorrigido
        );
        somasMensal.ratCorrigido += toTwoDecimals(verba.ratCorrigido);
        somasMensal.totalCorrigido +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCorrigido)
            : toTwoDecimals(verba.totalCprbCorrigido);
        somasMensal.valorCorrecao +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCalculado)
            : toTwoDecimals(verba.totalCprbCalculado);
      });

      reportData.push({
        "<style bold>Período</style>": "",
        "<style bold>CNPJ</style>": "",
        "<style bold>Código</style>": "",
        "<style bold>Evento</style>": "",
        "<style bold>Incidência</style>":
          "<style bold>Sub Total INCIDÊNCIA</style>",
        "<style bold>Valor Base</style>": toTwoDecimals(
          somasProvento.valorBase
        ),
        "<style bold>INSS</style>": toTwoDecimals(somasProvento.inss),
        "<style bold>Terceiros</style>": toTwoDecimals(somasProvento.terceiros),
        "<style bold>Rat</style>": toTwoDecimals(somasProvento.rat),
        "<style bold>Total</style>": toTwoDecimals(somasProvento.total),
        "<style bold>INSS Corrigido</style>": toTwoDecimals(
          somasProvento.inssCorrigido
        ),
        "<style bold>Terceiros Corrigido</style>": toTwoDecimals(
          somasProvento.terceirosCorrigido
        ),
        "<style bold>Rat Corrigido</style>": toTwoDecimals(
          somasProvento.ratCorrigido
        ),
        "<style bold>Total Corrigido</style>": toTwoDecimals(
          somasProvento.totalCorrigido
        ),
        "<style bold>Selic</style>": "",
        "<style bold>Valor Correção</style>": toTwoDecimals(
          somasProvento.valorCorrecao
        ),
      });

      let verbasDescontoPeriodo = verbasDescontoPorMes.get(value);

      verbasDescontoPeriodo = verbasDescontoPeriodo
        ? verbasDescontoPeriodo.sort((a, b) => {
            if (a.codigoRubrica < b.codigoRubrica) return -1;
            if (a.codigoRubrica > b.codigoRubrica) return 1;
            if (a.idTabelaRubrica < b.idTabelaRubrica) return -1;
            if (a.idTabelaRubrica > b.idTabelaRubrica) return 1;
            return 0;
          })
        : [];

      verbasDescontoPeriodo.forEach((verba) => {
        reportData.push({
          "<style bold>Período</style>": toMMYYYY(verba.periodoApuracao),
          "<style bold>CNPJ</style>": verba.cnpj,
          "<style bold>Código</style>": verba.codigoRubrica,
          "<style bold>Evento</style>": verba.descricaoRubrica,
          "<style bold>Incidência</style>": verba.incidenciaRubrica,
          "<style bold>Valor Base</style>": toTwoDecimals(verba.valorRubrica),
          "<style bold>INSS</style>": toTwoDecimals(verba.inss),
          "<style bold>Terceiros</style>": toTwoDecimals(verba.terceiros),
          "<style bold>Rat</style>": toTwoDecimals(verba.rat),
          "<style bold>Total</style>":
            calculoRelatorio === "geral"
              ? toTwoDecimals(verba.totalGeral)
              : toTwoDecimals(verba.totalCprb),
          "<style bold>INSS Corrigido</style>": toTwoDecimals(
            verba.inssCorrigido
          ),
          "<style bold>Terceiros Corrigido</style>": toTwoDecimals(
            verba.terceirosCorrigido
          ),
          "<style bold>Rat Corrigido</style>": toTwoDecimals(
            verba.ratCorrigido
          ),
          "<style bold>Total Corrigido</style>":
            calculoRelatorio === "geral"
              ? toTwoDecimals(verba.totalGeralCorrigido)
              : toTwoDecimals(verba.totalCprbCorrigido),
          "<style bold>Selic</style>": toTwoDecimals(verba.selic),
          "<style bold>Valor Correção</style>":
            calculoRelatorio === "geral"
              ? toTwoDecimals(verba.totalGeralCalculado)
              : toTwoDecimals(verba.totalCprbCalculado),
        });

        somasDesconto.valorBase += toTwoDecimals(verba.valorRubrica);
        somasDesconto.inss += toTwoDecimals(verba.inss);
        somasDesconto.terceiros += toTwoDecimals(verba.terceiros);
        somasDesconto.rat += toTwoDecimals(verba.rat);
        somasDesconto.total +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeral)
            : toTwoDecimals(verba.totalCprb);
        somasDesconto.inssCorrigido += toTwoDecimals(verba.inssCorrigido);
        somasDesconto.terceirosCorrigido += toTwoDecimals(
          verba.terceirosCorrigido
        );
        somasDesconto.ratCorrigido += toTwoDecimals(verba.ratCorrigido);
        somasDesconto.totalCorrigido +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCorrigido)
            : toTwoDecimals(verba.totalCprbCorrigido);
        somasDesconto.valorCorrecao +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCalculado)
            : toTwoDecimals(verba.totalCprbCalculado);

        somasMensal.valorBase += toTwoDecimals(verba.valorRubrica);
        somasMensal.inss += toTwoDecimals(verba.inss);
        somasMensal.terceiros += toTwoDecimals(verba.terceiros);
        somasMensal.rat += toTwoDecimals(verba.rat);
        somasMensal.total +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeral)
            : toTwoDecimals(verba.totalCprb);
        somasMensal.inssCorrigido += toTwoDecimals(verba.inssCorrigido);
        somasMensal.terceirosCorrigido += toTwoDecimals(
          verba.terceirosCorrigido
        );
        somasMensal.ratCorrigido += toTwoDecimals(verba.ratCorrigido);
        somasMensal.totalCorrigido +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCorrigido)
            : toTwoDecimals(verba.totalCprbCorrigido);
        somasMensal.valorCorrecao +=
          calculoRelatorio === "geral"
            ? toTwoDecimals(verba.totalGeralCalculado)
            : toTwoDecimals(verba.totalCprbCalculado);
      });

      reportData.push({
        "<style bold>Período</style>": "",
        "<style bold>CNPJ</style>": "",
        "<style bold>Código</style>": "",
        "<style bold>Evento</style>": "",
        "<style bold>Incidência</style>":
          "<style bold>Sub Total DESCONTO</style>",
        "<style bold>Valor Base</style>": toTwoDecimals(
          somasDesconto.valorBase
        ),
        "<style bold>INSS</style>": toTwoDecimals(somasDesconto.inss),
        "<style bold>Terceiros</style>": toTwoDecimals(somasDesconto.terceiros),
        "<style bold>Rat</style>": toTwoDecimals(somasDesconto.rat),
        "<style bold>Total</style>": toTwoDecimals(somasDesconto.total),
        "<style bold>INSS Corrigido</style>": toTwoDecimals(
          somasDesconto.inssCorrigido
        ),
        "<style bold>Terceiros Corrigido</style>": toTwoDecimals(
          somasDesconto.terceirosCorrigido
        ),
        "<style bold>Rat Corrigido</style>": toTwoDecimals(
          somasDesconto.ratCorrigido
        ),
        "<style bold>Total Corrigido</style>": toTwoDecimals(
          somasDesconto.totalCorrigido
        ),
        "<style bold>Selic</style>": "",
        "<style bold>Valor Correção</style>": toTwoDecimals(
          somasDesconto.valorCorrecao
        ),
      });

      reportData.push({
        "<style bold>Período</style>": "",
        "<style bold>CNPJ</style>": "",
        "<style bold>Código</style>": "",
        "<style bold>Evento</style>": "",
        "<style bold>Incidência</style>":
          "<style bold>Sub Total Mês " + toMMYYYY(value) + "</style>",
        "<style bold>Valor Base</style>": toTwoDecimals(somasMensal.valorBase),
        "<style bold>INSS</style>": toTwoDecimals(somasMensal.inss),
        "<style bold>Terceiros</style>": toTwoDecimals(somasMensal.terceiros),
        "<style bold>Rat</style>": toTwoDecimals(somasMensal.rat),
        "<style bold>Total</style>": toTwoDecimals(somasMensal.total),
        "<style bold>INSS Corrigido</style>": toTwoDecimals(
          somasMensal.inssCorrigido
        ),
        "<style bold>Terceiros Corrigido</style>": toTwoDecimals(
          somasMensal.terceirosCorrigido
        ),
        "<style bold>Rat Corrigido</style>": toTwoDecimals(
          somasMensal.ratCorrigido
        ),
        "<style bold>Total Corrigido</style>": toTwoDecimals(
          somasMensal.totalCorrigido
        ),
        "<style bold>Selic</style>": "",
        "<style bold>Valor Correção</style>": toTwoDecimals(
          somasMensal.valorCorrecao
        ),
      });

      reportData.push({
        "<style bold>Período</style>": "",
        "<style bold>CNPJ</style>": "",
        "<style bold>Código</style>": "",
        "<style bold>Evento</style>": "",
        "<style bold>Incidência</style>": "",
        "<style bold>Valor Base</style>": "",
        "<style bold>INSS</style>": "",
        "<style bold>Terceiros</style>": "",
        "<style bold>Rat</style>": "",
        "<style bold>Total</style>": "",
        "<style bold>INSS Corrigido</style>": "",
        "<style bold>Terceiros Corrigido</style>": "",
        "<style bold>Rat Corrigido</style>": "",
        "<style bold>Total Corrigido</style>": "",
        "<style bold>Selic</style>": "",
        "<style bold>Valor Correção</style>": "",
      });

      somasTotal.valorBase += toTwoDecimals(somasMensal.valorBase);
      somasTotal.inss += toTwoDecimals(somasMensal.inss);
      somasTotal.terceiros += toTwoDecimals(somasMensal.terceiros);
      somasTotal.rat += toTwoDecimals(somasMensal.rat);
      somasTotal.total += toTwoDecimals(somasMensal.total);
      somasTotal.inssCorrigido += toTwoDecimals(somasMensal.inssCorrigido);
      somasTotal.terceirosCorrigido += toTwoDecimals(
        somasMensal.terceirosCorrigido
      );
      somasTotal.ratCorrigido += toTwoDecimals(somasMensal.ratCorrigido);
      somasTotal.totalCorrigido += toTwoDecimals(somasMensal.totalCorrigido);
      somasTotal.valorCorrecao += toTwoDecimals(somasMensal.valorCorrecao);
    });

    reportData.push({
      "<style bold>Período</style>": "",
      "<style bold>CNPJ</style>": "",
      "<style bold>Código</style>": "",
      "<style bold>Evento</style>": "",
      "<style bold>Incidência</style>": "<style bold>Total Relatório</style>",
      "<style bold>Valor Base</style>": toTwoDecimals(somasTotal.valorBase),
      "<style bold>INSS</style>": toTwoDecimals(somasTotal.inss),
      "<style bold>Terceiros</style>": toTwoDecimals(somasTotal.terceiros),
      "<style bold>Rat</style>": toTwoDecimals(somasTotal.rat),
      "<style bold>Total</style>": toTwoDecimals(somasTotal.total),
      "<style bold>INSS Corrigido</style>": toTwoDecimals(
        somasTotal.inssCorrigido
      ),
      "<style bold>Terceiros Corrigido</style>": toTwoDecimals(
        somasTotal.terceirosCorrigido
      ),
      "<style bold>Rat Corrigido</style>": toTwoDecimals(
        somasTotal.ratCorrigido
      ),
      "<style bold>Total Corrigido</style>": toTwoDecimals(
        somasTotal.totalCorrigido
      ),
      "<style bold>Selic</style>": "",
      "<style bold>Valor Correção</style>": toTwoDecimals(
        somasTotal.valorCorrecao
      ),
    });

    return [reportData, fileName];
  };

  const obterRelatorioSefip = async () => {
    let folhaData = [];
    let fileName = "";
    let cnpj;

    currentData.forEach((verba) => {
      if (!cnpj) cnpj = verba.cnpj;
    });

    let periodos = [...currentData];

    periodos = periodos.sort((a, b) => a.periodoApuracao - b.periodoApuracao);

    periodos.forEach((periodo) => {
      folhaData.push({
        "<style bold>CNPJ</style>": periodo.cnpj.replaceAll(/[\.\/-]/g, ""),
        "<style bold>Período</style>": periodo.periodoApuracao,
        "<style bold>Total Corrigido</style>":
          calculoRelatorio === "geral"
            ? toTwoDecimals(periodo.totalGeralCorrigido)
            : toTwoDecimals(periodo.totalCprbCorrigido),
        "<style bold>Carga Sefip</style>":
          calculoRelatorio === "geral"
            ? periodo.cargaSefipGeral
            : periodo.cargaSefipCprb,
      });
    });

    return [folhaData, fileName];
  };

  const idsEmpresaSelecionados = normalizarIdsEmpresaResumo(grupoECnpj.CNPJ);
  const codigoComboContasEsocial =
    idsEmpresaSelecionados.length > 0
      ? `ESOCIAL_CONTAS_COMPOSICAO_${idsEmpresaSelecionados.join(",")}`
      : undefined;

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <>
            <Summarize fontSize="30px" />
          </>
        }
        headerTitle="Resumo Geral"
        disableModalButton
        disableSearch
        AutoCompleteRequired={grupoECnpj.CNPJ > 0 ? false : true}
        AutoCompleteGrupoECnpj
        handleGrupoECnpjChange={handleGrupoECnpjChange}
      />

      <div className={styles.backgroundContainer}>
        <Grid
          container
          spacing={1}
          columnSpacing={1}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "end",
            justifyContent: "end",
          }}
        >
          <Grid
            item
            size="auto"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className={styles.iconeSubTitulo}>
                <Calculate />
              </div>
              <h1 className={styles.subTitulo}>Cálculo</h1>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={calculoRelatorio}
                onChange={(event) => {
                  setCalculoRelatorio(event.target.value);
                }}
              >
                <FormControlLabel
                  value="geral"
                  control={<Radio />}
                  label="Geral"
                />
                <FormControlLabel
                  value="cprb"
                  control={<Radio />}
                  label="CPRB"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={sefipRelatorio}
                      onChange={(event) => {
                        setSefipRelatorio(event.target.checked);
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="Sefip"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={filtroBeneficios}
                      onChange={(event) => {
                        setFiltroBeneficios(event.target.checked);
                      }}
                      inputProps={{ "aria-label": "filtro-beneficios" }}
                    />
                  }
                  label="Benefícios"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={filtroComposicaoProjeto}
                      onChange={(event) => {
                        setFiltroComposicaoProjeto(event.target.checked);
                      }}
                      inputProps={{ "aria-label": "filtro-composicao-projeto" }}
                    />
                  }
                  label="Composição de Projeto"
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Grid
            item
            size="auto"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className={styles.iconeSubTitulo}>
                <RequestQuote />
              </div>
              <h1 className={styles.subTitulo}>Verbas</h1>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={verbasRelatorio}
                onChange={(event) => {
                  setVerbasRelatorio(event.target.value);
                }}
              >
                <FormControlLabel
                  value="Completo"
                  control={<Radio />}
                  label="Completo"
                />
                <FormControlLabel
                  value="Provento"
                  control={<Radio />}
                  label="Provento"
                />
                <FormControlLabel
                  value="Desconto"
                  control={<Radio />}
                  label="Desconto"
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Grid
            item
            xs={3.5}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className={styles.iconeSubTitulo}>
                <CalendarMonth />
              </div>
              <h1 className={styles.subTitulo}>Datas</h1>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Grid item xs={6} sx={{ paddingTop: "0px !important" }}>
                  <GenericYearMonthPicker
                    className={styles.yearMonth}
                    variant="standard"
                    onChange={handleDataInicial}
                    label={"Data Inicial"}
                  />
                </Grid>
                <Grid item xs={6} sx={{ paddingTop: "0px !important" }}>
                  <GenericYearMonthPicker
                    className={styles.yearMonth}
                    variant="standard"
                    onChange={handleDataFinal}
                    label={"Data Final"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          columnSpacing={4}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "end",
            justifyContent: "end",
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              // alignItems: "end",
              // justifyContent: "end",
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className={styles.iconeSubTitulo}>
                <CalendarMonth />
              </div>
              <h1 className={styles.subTitulo}>Contas</h1>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Grid item xs={12} sx={{ padding: "0px" }}>
                  <GenericTextIdAutoCompleteSelect
                    codigoCombo={codigoComboContasEsocial}
                    disabled={idsEmpresaSelecionados.length === 0}
                    label={""}
                    value={filtroContas}
                    onChange={(value) => {
                      setFiltroContas(value);
                    }}
                    selectAllItem
                    replaceId={"codigoRubrica"}
                    replaceLabel={"descricao"}
                    placeholder={"Pesquise contas..."}
                    variant={"standard"}
                    multiple
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <TabelaDinamica
        data={currentData}
        columns={currentColumns}
        loading={loading}
        extraProps={
          <Grid item xs={2} className={styles.buttonPadding}>
            <ExportExcelButton
              buttonLabel={"Download"}
              retrieveData={obterRelatorio}
              retrieveCabecalho={obterCabecalho}
            />
          </Grid>
        }
        disableDelete
        disableEdit
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default ResumoGeral;
